import React from "react";
import "../../App.css";

export default function AuthError() {
  return (
    <div className="container">
      <p className="text-danger">Please Login or Register an Account</p>
    </div>
  );
}
